<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3 grid-margin stretch-card border-right">
                            <div class="wrapper mt-4">
                                <categories-list/>
                            </div>
                        </div>
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-md-9">
                                    <h5 class="card-title mb-4">Items</h5>
                                </div>
                                <div class="col-md-3">
                                    <button class="btn btn-primary btn-block"
                                            @click="handleBtnNew">
                                        <i class="mdi mdi-plus"></i>Add New Item
                                    </button>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="table center-aligned-table">
                                    <thead>
                                        <tr>
                                            <th class="border-bottom-0">No.</th>
                                            <th class="border-bottom-0">Name</th>
                                            <th class="border-bottom-0">Description</th>
                                            <th class="border-bottom-0">Price</th>
                                            <th class="border-bottom-0">Category</th>
                                            <th class="border-bottom-0"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(i, index) in items">
                                            <td> {{ index + 1 }} </td>
                                            <td> {{ i.itemName }} </td>
                                            <td class="text-limit"> {{ i.description }} </td>
                                            <td> {{ i.originalPrice }} </td>
                                            <td> {{ i.category }} </td>
                                            <td>
                                                <b-button-group>
                                                    <b-button variant="primary" 
                                                            class="icon-btn"
                                                            v-on:click="handleBtnEdit(i)">
                                                        <i class="mdi mdi-table-edit"></i>
                                                    </b-button>
                                                    <b-button variant="danger" 
                                                            class="icon-btn"
                                                            v-on:click="handleBtnDelete(i)">
                                                        <i class="mdi mdi-delete-forever"></i>
                                                    </b-button>
                                                </b-button-group>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapState } from'vuex'
import CategoriesList from '../Categories/CategoriesList'
import RestaurantChangedBase from '../Bases/RestaurantChangedBase'
export default{
    name: 'items',
    extends: RestaurantChangedBase,
    components : {
        CategoriesList
    },
    computed: {
        ...mapState({
            items: state => state.items.items
        })
    },
    methods: {
        handleBtnNew() {
            this.$router.push( { name: 'itemaddform' });
        },
        handleBtnEdit(item) {
            this.$router.push({ name: 'itemeditform', params: { id: item.itemId }});
        },
        handleBtnDelete(item) {
            this.$store.dispatch('items/deleteItemAction', item);
        }
    },
    async created() {
        await this.$store.dispatch('restaurants/getRestaurantsAction');
        this.$store.commit('loading/setLoadingState', false);
        this.$store.dispatch('items/getItemsAction');
        this.setAction('items/getItemsAction');
    }
}
</script>

<style lang="scss">
   .text-limit {
       white-space: nowrap;
       overflow: hidden;
       text-overflow: ellipsis;
       max-width: 200px;
   }

   .text-limit:hover {
       overflow: hidden;
   }
</style>